import React, { useRef } from "react";
import VillaCard from "../villacard/VillaCard";
import { assets } from "../../assets/assets";
import "./style/cardinteractive.css";
function CardInteractive({
  isOpen,
  onToggle,
  villa,
  lang,
  onOpenModal,
  isMobile,
}) {
  const bodyRef = useRef(null);

  return (
    <div
      className="card-interactive"
      style={{
        // height: isOpen ? "calc(100vh - 86px)" : "50px",
        height: isMobile
          ? isOpen
            ? "auto"
            : "50px"
          : isOpen
            ? "calc(100vh - 86px)"
            : "50px",
            // bottom: isMobile ? "40px" : "0px",
      }}
    >
      <button
        className="card-interactive-button"
        onClick={() => onToggle(!isOpen)}
      >
        {isOpen ? "Hide Menu" : "Show Menu"}
        <img src={assets.filter} alt="Hide Menu" />
      </button>

      <div
        className="card-interactive-body"
        ref={bodyRef}
        style={{
          opacity: isOpen ? 1 : 0,
        }}
      >
        <VillaCard
          page="explore-tour"
          villa={villa}
          lang={lang}
          onOpenModal={onOpenModal}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
}

export default CardInteractive;
